import { createContext, useCallback, useState, useContext } from 'react';

export type DpBenefitsDrawerState = { title: string; emsName: string };

export interface DpBenefitsContextType {
	openDrawer?: DpBenefitsDrawerState;
	onOpenDrawer: (args: DpBenefitsDrawerState) => void;
	onCloseDrawer: () => void;
}

const dpBenefitsInitialState: DpBenefitsContextType = {
	openDrawer: undefined,
	onOpenDrawer: () => null,
	onCloseDrawer: () => null,
};

export const DpBenefitsContext = createContext<DpBenefitsContextType>(dpBenefitsInitialState);
export const DpBenefitsProvider = DpBenefitsContext.Provider;

export const useDpBenefits = () => {
	const [openDrawer, setOpenDrawer] = useState<DpBenefitsDrawerState | undefined>(undefined);

	const onOpenDrawer = useCallback((args: DpBenefitsDrawerState) => setOpenDrawer(args), []);

	const onCloseDrawer = useCallback(() => setOpenDrawer(undefined), []);

	return { openDrawer, onOpenDrawer, onCloseDrawer };
};

export const useDpBenefitsContext = () => {
	const context = useContext(DpBenefitsContext);

	if (!context) {
		throw new Error('DpBenefitsContext not found');
	}

	return context;
};
